import { styled, css } from 'styled-components';

export const Content = styled.svg<{ $type: 'green' | 'red' }>`
  ${({ theme: { colors }, $type }) => css`
    position: absolute;
    height: 1.125rem;
    left: -0.0675rem;
    top: -0.0675rem;
    width: 1.125rem;
    z-index: -1;

    .track {
      fill: none;
      stroke: ${colors.brandDarkTint80};
    }

    .progress {
      fill: none;
      stroke: ${$type === 'green' ? colors.semanticSuccessShade10 : colors.semanticDanger};
      stroke-linecap: round;
      transform: rotate(-90deg);
      transform-origin: 50% 50%;
    }
  `}
`;
